var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"list-toggler hover-list-element text-body-2",on:{"click":function($event){_vm.computedValue = !_vm.computedValue}}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"list-toggler-text text-body-2"},[_vm._v(" "+_vm._s(_vm.computedValue ? _vm.toggleOffTitle : _vm.toggleOnTitle)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }